export const addBorderClasses = ({ showBorderLeft, showBorderRight, isRtl }) => [
    ...[
        showBorderLeft ? (isRtl ? 'show-border-right' : 'show-border-left') : '',
    ],
    ...[
        showBorderRight ? (isRtl ? 'show-border-left' : 'show-border-right') : '',
    ],
].join(' ');
//# sourceMappingURL=common.js.map